var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMisc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C9 0.447715 9.44771 0 10 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893L16.7071 2.29289C17.0976 2.68342 17.0976 3.31658 16.7071 3.70711L14.7071 5.70711C14.5196 5.89464 14.2652 6 14 6H11V8H15C16.3261 8 17.5979 8.52678 18.5355 9.46447C19.4732 10.4021 20 11.6739 20 13V19C20 19.5523 19.5523 20 19 20H1C0.447715 20 0 19.5523 0 19V12.5C0 11.3065 0.474106 10.1619 1.31802 9.31802C2.16193 8.47411 3.30653 8 4.5 8H9V1ZM11 4H13.5858L14.5858 3L13.5858 2H11V4ZM8.24168 10C8.73249 10.7346 9 11.6035 9 12.5V18H18V13C18 12.2044 17.6839 11.4413 17.1213 10.8787C16.5587 10.3161 15.7956 10 15 10H8.24168ZM7 18V12.5C7 11.837 6.73661 11.2011 6.26777 10.7322C5.79893 10.2634 5.16304 10 4.5 10C3.83696 10 3.20107 10.2634 2.73223 10.7322C2.26339 11.2011 2 11.837 2 12.5V18H7ZM3 13C3 12.4477 3.44772 12 4 12H5C5.55228 12 6 12.4477 6 13C6 13.5523 5.55228 14 5 14H4C3.44772 14 3 13.5523 3 13Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/misc.43c7a00fca45cefb75eb2c92abe5422d.svg";
export { ForwardRef as ReactComponent };